import { NavLink } from 'react-router-dom';
import { hasAdminCapability, useAuth } from '@services/auth';

const links = [
	{ to: '/app/admin/analytics', label: 'Overview', icon: 'bi-bar-chart-line', capability: 'admin_analytics' as const },
	{ to: '/app/admin/engagement', label: 'Engagement', icon: 'bi-people-fill', capability: 'admin_engagement' as const },
	{ to: '/app/admin/user-activity', label: 'User activity', icon: 'bi-person-lines-fill', capability: 'admin_user_activity' as const }
];

export default function AdminAnalyticsNav() {
	const { user } = useAuth();
	const visibleLinks = links.filter((item) => hasAdminCapability(user, item.capability));

	return (
		<ul className="nav nav-pills gap-2 mb-4">
			{visibleLinks.map((item) => (
				<li key={item.to} className="nav-item">
					<NavLink
						to={item.to}
						className={({ isActive }) =>
							`nav-link d-inline-flex align-items-center gap-2 ${isActive ? 'active' : 'bg-body-tertiary text-body'}`
						}
					>
						<i className={`bi ${item.icon}`} />
						<span>{item.label}</span>
					</NavLink>
				</li>
			))}
		</ul>
	);
}
